import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik, useField } from "formik";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import moment from "moment";

//
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

//Services
import LocationApi from "Services/Location";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RestrictedLocationModalCreate = (props) => {
  const { open, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [values, setValues] = useState(null);
  const [locationData, setLocationData] = useState([]);
  const [locationId, setLocationId] = useState([]);
  const [locationName, setLocationName] = useState("");

  //pagination

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState("unlimited");

  //Time pickers

  const [startingTime, setStartingTime] = useState(null);
  const [endingTime, setEndingTime] = useState(null);

  const [startingTimeData, setStartingTimeData] = useState([]);
  const [endingTimeData, setEndingTimeData] = useState([]);

  const getAllLocations = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        setValues(res?.data?.data?.data);
      } else {
        setValues(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.data?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    LocationApi.getServiceArea().then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    open && getAllLocations();
  }, [open]);

  //Add restrict location

  const AddRestrictLocation = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
    const selectedLocation = locationData.find(
      (location) => location.locationName === formValues?.locationName
    );

    let theLocationId;

    if (selectedLocation) {
      theLocationId = selectedLocation._id;
    }

    let data = {
      locationId: theLocationId,
      restrictionType: formValues?.restrictType,
      startingTime: {
        hour: startingTimeData?.hour,
        minutes: startingTimeData?.minutes,
        seconds: startingTimeData?.seconds,
        timeFormat: startingTimeData?.timeFormat,
      },
      endingTime: {
        hour: endingTimeData?.hour,
        minutes: endingTimeData?.minutes,
        seconds: endingTimeData?.seconds,
        timeFormat: endingTimeData?.timeFormat,
      },
    };

    const onSuccess = (res) => {
      formik.setFieldValue("locationName", "");
      formik.setFieldValue("restrictType", "PICKUP");
      setStartingTime(null);
      setEndingTime(null);
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: res?.data?.message || "Updated successfully",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        })
      );
      handleClose();
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while updating",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    LocationApi.restrictLocationCreate(data).then(onSuccess, onFailure);
  };

  // Formik

  const formik = useFormik({
    initialValues: {
      locationName: "",
      restrictType: "PICKUP",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      locationName: yup
        .string()
        .required("location is required")
        .trim()
        .min(3, "Name must be atleast 3 letters")
        .max(50, "Max 50 characters are allowed")
        .nullable(),
    }),
    onSubmit: AddRestrictLocation,
  });

  // Formik - Set fetched values for master
  useEffect(() => {
    if (!_.isEmpty(values)) {
      //console.log("the values ", values);
      setLocationData(values);
    }
  }, [values]);

  const handleAutocompleteChange = (event, value) => {
    formik.setFieldValue("locationName", value);
  };

  //handle startingTime change

  const handleStartingTimeChange = (newValue) => {
    setStartingTime(newValue);

    if (newValue) {
      // Convert newValue to a Date object if it's not already
      const selectedDate =
        newValue instanceof Date ? newValue : new Date(newValue);

      // Extracting hour, minutes, and seconds
      const hour = selectedDate.getHours();
      const minutes = selectedDate.getMinutes();
      const seconds = selectedDate.getSeconds();

      // Determine time format (12-hour or 24-hour)
      const timeFormat = hour >= 12 ? 12 : 24;

      // Update state or perform any other action with the extracted values
      // console.log({
      //   hour,
      //   minutes,
      //   seconds,
      //   timeFormat,
      // });

      setStartingTimeData({
        hour,
        minutes,
        seconds,
        timeFormat,
      });
    }
  };

  const handleEndingTimeChange = (newValue) => {
    setEndingTime(newValue);
    if (newValue < startingTime) {
      formik.setFieldError(
        "endingTime",
        "Ending time cannot be less than starting time"
      );
      //console.log("endingTime error ", startingTime);
    } else {
      if (newValue) {
        // Convert newValue to a Date object if it's not already
        const selectedDate =
          newValue instanceof Date ? newValue : new Date(newValue);

        // Extracting hour, minutes, and seconds
        const hour = selectedDate.getHours();
        const minutes = selectedDate.getMinutes();
        const seconds = selectedDate.getSeconds();

        // Determine time format (12-hour or 24-hour)
        const timeFormat = hour >= 12 ? 12 : 24;

        // Update state or perform any other action with the extracted values
        // console.log({
        //   hour,
        //   minutes,
        //   seconds,
        //   timeFormat,
        // });
        setEndingTimeData({ hour, minutes, seconds, timeFormat });
      }
    }
  };

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Add Restriction Location
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <section className={classes.container}>
              <Grid item xs={12} className={classes.avatarContainer}></Grid>
              <Grid item xs={12} className={classes.detailsContainer}>
                <Grid item xs={12}>
                  <div className={classes.header}>
                    <Typography variant="body1">
                      Add Restrict Location
                    </Typography>
                  </div>
                </Grid>
                <Grid container className={classes.containerWrapper}>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      style={{ margin: "20px 0px" }}
                    >
                      <Autocomplete
                        disablePortal
                        name="locationName"
                        id="locationName"
                        label="locationName"
                        value={formik?.values?.locationName}
                        defaultValue={formik?.values?.locationName}
                        onChange={handleAutocompleteChange}
                        options={locationData.map(
                          (location) => location.locationName
                        )}
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select a Location"
                            error={
                              formik?.errors?.locationName &&
                              formik?.touched?.locationName
                            }
                            helperText={
                              formik?.errors?.locationName &&
                              formik?.touched?.locationName &&
                              formik?.errors?.locationName
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                      <TextField
                        name="restrictType"
                        id="restrictType"
                        select
                        label="Restrict Type"
                        value={formik?.values?.restrictType}
                        defaultValue={formik?.values?.restrictType}
                        onChange={formik?.handleChange}
                        error={
                          formik?.errors?.restrictType &&
                          formik?.touched?.restrictType
                        }
                        helperText={
                          formik?.errors?.restrictType &&
                          formik?.touched?.restrictType &&
                          formik?.errors?.restrictType
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                      >
                        {["PICKUP", "DROP", "ALL"].map((option) => (
                          <MenuItem key={option} value={option}>
                            {option === "PICKUP"
                              ? "Pickup"
                              : option === "DROP"
                              ? "Drop"
                              : "All"}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid
                      container
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.containerWrapper}
                    >
                      <Grid item xs={12} md={6} lg={6} xl={6}>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          size="small"
                        >
                          <TimePicker
                            name="startingTime"
                            id="startingTime"
                            label="Starting Time"
                            value={startingTime}
                            size="small"
                            className={classes.timePickerStyle}
                            onChange={(newValue) => {
                              handleStartingTimeChange(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={
                                  formik?.errors?.startingTime &&
                                  formik?.touched?.startingTime
                                }
                                helperText={
                                  formik?.errors?.startingTime &&
                                  formik?.touched?.startingTime &&
                                  formik?.errors?.startingTime
                                }
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6} xl={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            name="endingTime"
                            id="endingTime"
                            label="Ending Time"
                            value={endingTime}
                            size="small"
                            className={classes.timePickerStyle}
                            onChange={(newValue) => {
                              handleEndingTimeChange(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={
                                  formik?.errors?.endingTime &&
                                  formik?.errors?.endingTime
                                }
                                helperText={
                                  formik?.errors?.endingTime &&
                                  formik?.errors?.endingTime
                                }
                              />
                            )}
                          />
                        </LocalizationProvider>
                        {/* <Typography>{formik?.errors?.endingTime}</Typography> */}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container xs={12} md={12} lg={12} xl={12}>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{
                      float: "right",
                      margin: "30px 10px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    <Button variant="contained" onClick={formik?.handleSubmit}>
                      Add Restriction
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </section>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>Close</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RestrictedLocationModalCreate;
